import Vue from 'vue'
import Router from 'vue-router'
import EventBus from '../utils/EventBus'
import Home from '@/components/Home/Home'
import Content from '@/components/Home/Content'
import Login from '@/components/Login/Login'
import DistributionApplication from '@/view/DistributionApplication/DistributionApplication'
import FlightDetails from '@/view/DistributionApplication/FlightDetails'
import SelectProduct from '@/view/DistributionApplication/SelectProduct'
import ConfirmProduct from '@/view/DistributionApplication/ConfirmProduct'
import ApplicationRecord from '@/view/ApplicationRecord/ApplicationRecord'
import ApplicationRecordSupply from '@/view/ApplicationRecord/ApplicationRecordSupply'
import ApplicationRecordDetails from '@/view/ApplicationRecord/ApplicationRecordDetails'
import ApplicationRecordSupplyDetails from '@/view/ApplicationRecord/ApplicationRecordSupplyDetails'
import DistributionApproval from '@/view/DistributionApproval/DistributionApproval'
import DistributionApprovalSupply from '@/view/DistributionApproval/DistributionApprovalSupply'
import DistributionApprovalDetails from '@/view/DistributionApproval/DistributionApprovalDetails'
import DistributionApprovalSupplyDetails from '@/view/DistributionApproval/DistributionApprovalSupplyDetails'
import OvernightBag from '@/view/OvernightBag/OvernightBag'
import OvernightBagDetails from '@/view/OvernightBag/OvernightBagDetails'
import OvernightCarDetails from '@/view/OvernightBag/OvernightCarDetails'
import OvernightBagManage from '@/view/OvernightBag/OvernightBagManage'
import OvernightCarManage from '@/view/OvernightBag/OvernightCarManage'
import OvernightBagManageOld from '@/view/OvernightBag/OvernightBagManageOld'
import OvernightBagManageDetails from '@/view/OvernightBag/OvernightBagManageDetails'
import OvernightCarManageDetails from '@/view/OvernightBag/OvernightCarManageDetails'
import OvernightBagManageDetailsOld from '@/view/OvernightBag/OvernightBagManageDetailsOld'
import OvernightBagAll from '@/view/OvernightBag/OvernightBagAll'
import OvernightBagAllDetails from '@/view/OvernightBag/OvernightBagAllDetails'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    { path: '/', redirect: '/mobile/Content' },
    { path: '/mobile', redirect: '/mobile/Content' },
    { path: '/login', component: Login },
    {
      path: '/mobile', name: 'Home', component: Home,
      children: [
        { path: '/mobile/Content', name: 'Content', component: Content },
        // 配货申请
        {
          path: '/mobile/DistributionApplication', name: 'DistributionApplication', component: DistributionApplication
        },
        // 航班详情
        {
          path: '/mobile/FlightDetails', name: 'FlightDetails', component: FlightDetails
        },
        // 选择商品
        {
          path: '/mobile/SelectProduct', name: 'SelectProduct', component: SelectProduct
        },
        // 确认商品
        {
          path: '/mobile/ConfirmProduct', name: 'ConfirmProduct', component: ConfirmProduct
        },
        // 申请记录
        {
          path: '/mobile/ApplicationRecord', name: 'ApplicationRecord', component: ApplicationRecord
        },
        // 供应商 申请记录
        {
          path: '/mobile/ApplicationRecordSupply', name: 'ApplicationRecordSupply', component: ApplicationRecordSupply
        },
        // 申请记录详情
        {
          path: '/mobile/ApplicationRecordDetails', name: 'ApplicationRecordDetails', component: ApplicationRecordDetails
        },
        // 供应商 申请记录详情
        {
          path: '/mobile/ApplicationRecordSupplyDetails', name: 'ApplicationRecordSupplyDetails', component: ApplicationRecordSupplyDetails
        },
        // 配货审批
        {
          path: '/mobile/DistributionApproval', name: 'DistributionApproval', component: DistributionApproval
        },
        // 供应商 配货审批
        {
          path: '/mobile/DistributionApprovalSupply', name: 'DistributionApprovalSupply', component: DistributionApprovalSupply
        },
        // 配货审批详情
        {
          path: '/mobile/DistributionApprovalDetails', name: 'DistributionApprovalDetails', component: DistributionApprovalDetails
        },
        // 供应商 配货审批详情
        {
          path: '/mobile/DistributionApprovalSupplyDetails', name: 'DistributionApprovalSupplyDetails', component: DistributionApprovalSupplyDetails
        },
        // 过夜袋
        {
          path: '/mobile/OvernightBag', name: 'OvernightBag', component: OvernightBag
        },
        // 过夜袋详情
        {
          path: '/mobile/OvernightBagDetails', name: 'OvernightBagDetails', component: OvernightBagDetails
        },
        // 过夜袋详情
        {
          path: '/mobile/OvernightCarDetails', name: 'OvernightCarDetails', component: OvernightCarDetails
        },
        // 过夜袋管理（账号登陆）
        {
          path: '/mobile/OvernightBagManage', name: 'OvernightBagManage', component: OvernightBagManage
        },
        {
          path: '/mobile/OvernightBagManageOld', name: 'OvernightBagManageOld', component: OvernightBagManageOld
        },
        // 销售车（账号登陆）
        {
          path: '/mobile/OvernightCarManage', name: 'OvernightCarManage', component: OvernightCarManage
        },
        // 过夜袋管理
        {
          path: '/mobile/OvernightBagAll', name: 'OvernightBagAll', component: OvernightBagAll
        },
        // 过夜袋管理详情
        {
          path: '/mobile/OvernightBagAllDetails', name: 'OvernightBagAllDetails', component: OvernightBagAllDetails
        },
        // 过夜袋管理详情（账号登陆）
        {
          path: '/mobile/OvernightBagManageDetails', name: 'OvernightBagManageDetails', component: OvernightBagManageDetails
        },
        {
          path: '/mobile/OvernightBagManageDetailsOld', name: 'OvernightBagManageDetailsOld', component: OvernightBagManageDetailsOld
        },
        // 过夜袋管理详情（账号登陆）
        {
          path: '/mobile/OvernightCarManageDetails', name: 'OvernightCarManageDetails', component: OvernightCarManageDetails
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => { // 路由拦截器
  let title = '机上销售'
  switch (to.name) {
    case 'DistributionApplication':
      title = '配货申请'
      break;
    case 'FlightDetails':
      title = '航班详情'
      break;
    case 'SelectProduct':
      title = '选择商品'
      break;
    case 'ConfirmProduct':
      title = '确认商品'
      break;
    case 'ApplicationRecord':
      title = '申请记录'
      break;
    case 'ApplicationRecordSupply':
      title = '申请记录'
      break;
    case 'ApplicationRecordDetails':
      title = '申请记录详情'
      break;
    case 'ApplicationRecordSupplyDetails':
      title = '申请记录详情'
      break;
    case 'DistributionApproval':
      title = '配货审批'
      break;
    case 'DistributionApprovalSupply':
      title = '配货审批'
      break;
    case 'DistributionApprovalDetails':
      title = '配货审批详情'
      break;
    case 'DistributionApprovalSupplyDetails':
      title = '配货审批详情'
      break;
    case 'OvernightBag':
      title = '航班信息'
      break;
    case 'OvernightBagDetails':
      title = '销售包详情'
      break;
    case 'OvernightCarDetails':
      title = '销售车详情'
      break;
    case 'OvernightBagManage':
      title = '销售包管理'
      break;
    case 'OvernightCarManage':
      title = '销售车管理'
      break;
    case 'OvernightBagAll':
      title = '销售包管理'
      break;
    case 'OvernightBagManageDetails':
      title = '销售包详情'
      break;
    case 'OvernightCarManageDetails':
      title = '销售车详情'
      break;
    case 'OvernightBagAllDetails':
      title = '销售包详情'
      break;

    default:
      break;
  }
  EventBus.$emit('setTitle', title)
  EventBus.$emit('setPageName', to.name)

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js